import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { EMAIL_PATTERN_STRING } from '../consts/patterns.const';

export function EmailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isArray = Array.isArray(control?.value);

    if ((control?.value || '').length === 0) {
      return null;
    }

    const emailRegex = new RegExp(EMAIL_PATTERN_STRING, 'i');

    const isValid = isArray ? control?.value.every((value) => emailRegex.test(value)) : control.value.match(emailRegex);

    return isValid ? null : { emailInvalid: true };
  };
}
